import React from 'react';
import { useDropzone } from 'react-dropzone';

import block from 'propmods';

import './PSDropZone.scss';

const b = block('PSDropZone');

interface Props {
    onDrop: (acceptedFiles: File[], rejectedFiles: File[]) => void;
    accept: string | string[] | undefined;
    uploadText: React.ReactNode;
    size?: 's' | 'l';
    maxSize?: number;
    minSize?: number;
    disabled?: boolean;
}

const PSDropZone: React.FC<Props> = ({ uploadText, size = 'l', minSize = 1, ...dropZoneProps }) => {
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ minSize, ...dropZoneProps });

    return (
        <div {...getRootProps()} {...b({ isDragActive, size })}>
            <input {...getInputProps()} />
            <div>{uploadText}</div>
        </div>
    );
};

export default PSDropZone;
